import React, { useEffect } from 'react';
import styles from './index.module.scss';
import FooterBlock from './footer_block';

const Footer = ({ contentData, path_to_folder }) => {

  // Вывод в консоль данных футера при получении
  // useEffect(() => {
  //   console.log('=== Footer: полученные данные ===');
  //   console.log('contentData:', contentData);
  //   console.log('path_to_folder:', path_to_folder);
  //   console.log('===============================');
  // }, [contentData, path_to_folder]);

  // Находим самую высокую высоту среди не-Common блоков
  const getMaxHeight = () => {
    if (!contentData || !Array.isArray(contentData)) return 0;

    const nonCommonBlocks = contentData.filter((block) => (block.boock_tag !== 'Common' && block.block_tag !== 'Common'));
    if (nonCommonBlocks.length === 0) return 0;

    // Возвращаем примерную высоту для расчета (можно настроить)
    return 200; // Базовая высота для всех не-Common блоков
  };

  const maxHeight = getMaxHeight();

  const renderBlock = (contentData, index) => {
    const isLastBlock = index === contentData.length - 1;
    return (
      <FooterBlock
        key={index}
        blockData={contentData}
        path_to_folder={path_to_folder}
        blockIndex={index}
        isLastBlock={isLastBlock}
        maxHeight={maxHeight}
      />
    );
  };

  return (
    <div className={styles.footer}>
      {contentData && Array.isArray(contentData) && (
        <div className={styles.blocksContainer}>
          {contentData.map((block, index) => renderBlock(block, index))}
        </div>
      )}
    </div>
  );
};

export default Footer;
